import React, { useEffect } from "react";

import { useParams, useNavigate } from "react-router-dom";
import projects from "../assets/projects/projects.json";

export default function PrivacyPolicy() {
  let navigate = useNavigate();
  let { id } = useParams();
  const project = projects.data.find((p) => p.id === id);
  useEffect(() => {
    if (!project) {
      navigate("/projects");
    }
  });

  return (
    <div>
      <h1 className="text-3xl font-extrabold tracking-tight text-gray-900 mb-5">
        {project.privacy_policy.title}
      </h1>
      {project.privacy_policy.content.map((paragraph) => (
        <p className="text-gray-900 leading-relaxed mb-5">{paragraph}</p>
      ))}
    </div>
  );
}
